import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import ReactApexChart from 'react-apexcharts'
import { getMonthlyResult } from '../../store/ducks/financial'
import Extrato from '../../components/Template/Doc/Extrato'

class FinancialResultGraph extends Component {
  constructor(props) {
    super(props)
    this.state = {
      extratoModalIsOpen: false,
    }
  }

  componentDidMount() {
    const { getMonthlyResult, mes, escopo } = this.props
    getMonthlyResult(mes, escopo)
  }

  handleChange = (e) => {
    this.props.atualizaMes(e)
    console.log(`Você selecionou o mês ${e}!`)
    //this.setState({extratoModalIsOpen: true})
  }

  render() {
    const {
      getMonthlyResultIsLoading, getMonthlyResultError, monthlyResult,
    } = this.props.financial

    const {
      extratoModalIsOpen,
    } = this.state

    const {
      handleChange,
    } = this

    if (getMonthlyResultIsLoading) {
      return (
        <Card>
          <CardBody>
            <h4 className="card-title mb-4">
              Resultado mensal
            </h4>
            <div>
              <div id="line-column-chart" className="apex-charts" dir="ltr">
                Carregando...
              </div>
            </div>
          </CardBody>
        </Card>
      )
    }

    if (getMonthlyResultError) return null

    if (!getMonthlyResultIsLoading && !getMonthlyResultError && monthlyResult) {
      const serieAcumulado = monthlyResult
        .map(item => item.acumulado)
      const serieReceita = monthlyResult
        .map(item => item.receita)
      const serieDespesa = monthlyResult
        .map(item => item.despesa)
      const serieResultado = monthlyResult
        .map(item => item.resultado)
      const serieLabel = monthlyResult
        .map(item => item.mes)

      const options = {
        labels: serieLabel,
        chart: {
          type: 'bar',
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: function(event, chartContext, config) {
              //console.log(config['dataPointIndex'])
              handleChange(config['dataPointIndex'])
            }
          },
        },
        stroke: {
          width: [0, 0, 0, 4],
          curve: 'smooth',
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        colors: ['#5664d2', '#1cbb8c', '#ffff00', '#3fa3ff'],
        yaxis: [{
          seriesName: 'Receita',
          labels: {
            formatter: (value) => {
              return value.toFixed(0)
            },
          },
          show: true,
          title: {
            text: 'Receita',
          },
        }, {
          seriesName: 'Receita',
          show: false,
          title: {
            text: 'Despesa',
          },
        }, {
          show: false,
          seriesName: 'Receita',
          title: {
            text: 'Resultado',
          },
        }, {
          opposite: true,
          labels: {
            formatter: (value) => {
              return value.toFixed(0)
            },
          },
          title: {
            text: 'Acumulado',
          },
        }],
      }

      const series = [{
        name: 'Receita',
        type: 'column',
        data: serieReceita,
      }, {
        name: 'Despesa',
        type: 'column',
        data: serieDespesa,
      }, {
        name: 'Resultado',
        type: 'column',
        data: serieResultado,
      }, {
        name: 'Acumulado',
        type: 'line',
        data: serieAcumulado,
      }]

      return (
        <>
        <Modal
          centered={false}
          isOpen={ extratoModalIsOpen}
          toggle={() => this.setState({ extratoModalIsOpen: false })}
        >
          <ModalHeader
            toggle={() => this.setState({
            extratoModalIsOpen: false,
          })}
          >
            Extrato
          </ModalHeader>
          <ModalBody>
            <Extrato mes="larara" />
          </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </Modal>



        <Card>
          <CardBody>
            <h4 className="card-title mb-4">
              Resultado mensal
            </h4>
            <div>
              <div id="line-column-chart" className="apex-charts" dir="ltr">
                <ReactApexChart
                  options={options}
                  series={series}
                  height="280"
                />
              </div>
            </div>
          </CardBody>
        </Card>
        </>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({ financial: state.financial })
const mapDispatchToProps = dispatch => bindActionCreators({ getMonthlyResult }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(FinancialResultGraph)
